import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import  { ItmpH2, ItmpBody } from './ItmpTypography'
import TanarImg from './img/tanar.png'
import { Link } from 'react-router-dom'

const NotFound = (props)=>{
	return (
		<Grid container style={{paddingTop: '50px'}} className="container">
			<Grid item md={12} xs={12} style={{}}>
				<Typography variant="h2" style={{color: '#f68e54', fontWeight: '500', textAlign: 'center'}}>A kért oldal nem található</Typography>
				<Link to="/">
					<Button variant="contained" color="secondary" size="large" style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)', margin: '20px 0'}}>Vissza a kezdőlapra</Button>
				</Link>
				<Divider style={{margin: '100px 0 30px 0'}} />
				
			</Grid>
			<Grid item md={9} xs={12}>
				<ItmpBody style={{textAlign: 'left', overflow: 'hidden'}}>
					<p>Az Infotanár Mentor Program működtetését a <a className="underline" href="https://mimox.com/" target="_blank">Mimox Kft.</a>
						és a <a className="underline" href="https://http-alapitvany.hu" target="_blank">HTTP Alapítvány</a> munkatársai végzik.
						 </p>
					<p>Kérdés esetén várjuk üzenetedet az <a className="underline" href="mailto:info@itmp.hu">info@itmp.hu</a> e-mail címre.</p>
					<p>

					</p>
						Facebook oldalunk: <a className="underline" href="https://www.facebook.com/groups/infotanarmentorprogram/" target="_main">
						https://www.facebook.com/groups/infotanarmentorprogram/
					
						</a>
					<p>
						Meetup oldalunk: <a className="underline" href="https://www.meetup.com/Igy-neveld-az-infosodat/" target="_main">
						https://www.meetup.com/Igy-neveld-az-infosodat/
						</a>
					</p>
					<p>&nbsp;</p>		
				</ItmpBody>
			</Grid>
			<Grid item md={3} xs={12}>
				<img src={TanarImg} style={{width: '100%', margin: '-10px 0 10px 0', transform: 'scaleX(1)'}} alt=""/>
			</Grid>
		</Grid>
	)
}

export default NotFound